import { z } from 'zod';

export const CreateIncomeSchema = z.object({
  departmentId: z.string().min(1, 'Department is required'),
  incomeTypeId: z.string().min(1, 'Income type is required'),
  amount: z.number().positive('Amount must be greater than 0'),
  accountId: z.string().min(1, 'Account is required'),
  notes: z.string().max(500).optional(),
  pcInfo: z
    .object({
      pcName: z.string(),
      pcId: z.string(),
      macAddress: z.string().optional(),
      ipAddress: z.string().optional(),
    })
    .optional(),
});

export type CreateIncome = z.infer<typeof CreateIncomeSchema>;

export const IncomeResponseSchema = z.object({
  _id: z.string(),
  incomeId: z.number(),
  receiptId: z.string(),
  verificationCode: z.string(),
  departmentId: z.string(),
  departmentName: z.string(),
  incomeTypeId: z.string(),
  incomeTypeName: z.string(),
  amount: z.number(),
  accountId: z.string(),
  accountName: z.string(),
  accountNumber: z.string(),
  notes: z.string().optional(),
  operatorId: z.string(),
  operatorName: z.string(),
  operatorRole: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type IncomeResponse = z.infer<typeof IncomeResponseSchema>;

export const IncomeListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  departmentId: z.string().optional(),
  incomeTypeId: z.string().optional(),
  accountId: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  search: z.string().optional(),
});

export type IncomeListQuery = z.infer<typeof IncomeListQuerySchema>;
